export default {
  title: '¡Este es un SAFE Tag!',
  subtitle: {
    isNotSosafeUser:
      'Descarga nuestra aplicación para escanear tu SAFE Tag y comenzar a estar protegido por SOSAFE',
  },
  downloadApp: 'Descargar SOSAFE',
};
